export default __webpack_public_path__ + "static/media/addon1.62927bb5.webp";